import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Drawer, Form, Input, Progress, Select } from "antd";
import PropTypes from "prop-types";

import { Modals } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import Upload from "components/Upload";

const Component = ({ data = {}, onUpdate }) => {
	const initialState = { progress: 0, aspect: 1 };
	const [state, setState] = useState(initialState);
	const { progress, submitting, visible, aspect } = state;
	const { id, section, title } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				const formData = new FormData();

				formData.append("title", values.title);
				formData.append("description", values.description);
				formData.append("section", values.section);

				console.log(values.file)
				// if (values.file) formData.append("file", values.file);
				if (values.file instanceof Blob) formData.append("file", values.file);
				if (id) formData.append("_method", "PUT");

				setState((prevState) => ({ ...prevState, submitting: true }));

				const action =
					hash === `#${Modals.CREATE}`
						? API.gallery.create(formData)
						: API.gallery.update(id, formData, (percent) => {
								setState((prevState) => ({ ...prevState, progress: percent }));
						  });

				action
					.then(() => {
						onUpdate(null, true);
						navigate(-1);
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							progress: 0,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.CREATE}`: {
				setState((prevState) => ({ ...prevState, visible: true }));

				break;
			}
			case `#${Modals.EDIT}`: {
				if (id) {
					setState((prevState) => ({ ...prevState, visible: true }));

					form.setFieldsValue(data);
					
				} else {
					navigate(`${pathname}${search}`, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Drawer
			className="sp-form-drawer"
			placement={process.env.REACT_APP_IS_RTL ? "left" : "right"}
			footer={
				<>
					<Button
						type="primary"
						onClick={handleSubmit}
						loading={submitting}
					>
						{Resources.confirm}
					</Button>
					<Button
						onClick={() => navigate(-1)}
						disabled={submitting}
					>
						{Resources.cancel}
					</Button>
				</>
			}
			onClose={() => navigate(-1)}
			title={
				hash === `#${Modals.CREATE}`
					? `${Resources.add} ${Resources.image}`
					: `${Resources.edit} ${Resources.image} "${title}"`
			}
			maskClosable={false}
			open={visible}
			width={414}
		>
			<Form
				layout="vertical"
				form={form}
			>
				<>
					<Form.Item
						name="title"
						label={Resources.title}
						rules={Rules.required}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="description"
						label={Resources.description}
						rules={Rules.required}
					>
						<Input.TextArea rows={4} />
					</Form.Item>

					<Form.Item
						name="section"
						label={Resources.section}
						rules={Rules.required}
					>
						<Select
							options={[
								{ label: Resources.user, value: "user" },
								{ label: Resources.category, value: "category" },
								{ label: Resources.course, value: "course" },
								{ label: Resources.package, value: "package" },
								{ label: Resources.session, value: "session" },
								{ label: Resources.banner, value: "banner" },
								{ label: Resources.sample, value: "sample" },
								{ label: Resources.platform, value: "platform" },
								{ label: Resources.default, value: "default" },
							]}
						/>
					</Form.Item>
					<Form.Item
						name="aspect"
						label={`${Resources.ratio} ${Resources.image}`}
						rules={Rules.required}
					>
						<Select
							options={[
								{ label: "1", value: 1 },
								{ label: "4:3", value: 4 / 3 },
								{ label: "16:9", value: 16 / 9 },
								{ label: "بدون تغییر نسبت", value: 0 },
							]}
							placeholder="1"
							onChange={(e) => {
								setState((prev) => ({ ...prev, aspect: e }));
							}}
						/>
					</Form.Item>




					<Form.Item
						name="file"
						label={Resources.file}
						rules={hash === `#${Modals.CREATE}` ? Rules.required : []}
					>
						<Upload
							aspect={aspect}
							uploadOptions={{ showUploadList: false }}
						/>
					</Form.Item>
					{submitting && <Progress percent={progress} />}
				</>
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
};

export default Component;
